import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import '../styles/card.css'

class Card extends Component {
  render () {
    const {options, full, video, modalLink, externalLink} = this.props
    const card = (
      <div className={'card' + ((externalLink === true) ? ' external-link' : '') + ((modalLink === true) ? ' modal-link' : '') + ((full === true) ? ' full' : '') + ((video === true) ? ' video' : '') + ((options.logo !== undefined) ? ' case' : '') + ((options.image !== undefined) ? ' image' : '')}>
        {options.video !== undefined &&
        <span>
          <video className='videoBackground' autoPlay muted playsInline loop poster={options.video + '.jpg'}>
            <source src={options.video + '.mp4'} type='video/mp4' />
            <source src={options.video + '.webm'} type='video/webm' />
            <source src={options.video + '.ogv'} type='video/ogg' />
          </video>
          <div className='mask' />
        </span>
        }
        {options.image !== undefined && <img className='imageGallery' alt={options.image} src={options.image + '.jpg'} />}
        {options.icon !== undefined && <i className={'ac ' + options.icon} />}
        {options.logo !== undefined && <div className='logo' style={{background: 'url(https://storage.googleapis.com/bronze-labs-static/images/clients/' + options.logo + ') no-repeat center left'}} />}
        {options.header !== undefined && <h3 dangerouslySetInnerHTML={{__html: options.header}} />}
        {options.text !== undefined && <span>{options.text}</span>}
        {options.texts !== undefined && options.texts.map((text, index) => <p key={index} dangerouslySetInnerHTML={{__html: text}} />)}
      </div>
    )
    if (this.props.options.url !== undefined) {
      return (
        <Link to={this.props.options.url} onClick={this.props.onClick}>
          {card}
        </Link>
      )
    }
    return card
  }
}

Card.propTypes = {
  onClick: PropTypes.func,
  options: PropTypes.object.isRequired,
  video: PropTypes.bool,
  full: PropTypes.bool,
  modalLink: PropTypes.bool,
  externalLink: PropTypes.bool
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card.js